import { useState } from 'react';

//constants
import { title, subtitle, epigraph1, epigraph2, urlVideo } from '../../Constants';
import Video from './Video';

const Home = () => {

    const [readMore, setReadMore] = useState(false);

    const handleReadMore = () => {
        setReadMore(!readMore);
    }

    return (
        <section className="container mx-auto px-0 container-al">
            <section className="mx-auto px-2 px-md-0 text-center cont-title">
                <h1 className="mt-3 mt-md-4 text-white title">{title}</h1>
                <h2 className="mb-3 mb-md-4 text-white subtitle">{subtitle}</h2>
                <article>                    
                    {
                        !readMore 
                            ? <>
                                <p className="mb-0 text-white epigraph">{epigraph1}</p>
                                <button
                                    type="button"
                                    className="d-flex justify-content-around mx-auto my-3 my-md-4 py-0 pe-2 rounded-pill border border-white btn-read"
                                    onClick={() => handleReadMore()}
                                >
                                    <span className="rounded-pill py-2 ps-0 fw-bolder text-white cross">+</span>
                                    <span className="py-1 px-0">LEER MÁS</span>
                                </button>  
                            </>   
                            : <>
                                <p className="mb-0 text-white epigraph">{epigraph2}</p>
                                <button
                                    type="button"
                                    className="my-3 my-md-4 rounded-pill border border-white py-1 px-3 btn-read-less"
                                    onClick={() => handleReadMore()}
                                >
                                    -
                                </button>  
                            </>  
                    }                        
                    <div className="w-100 mb-4 mb-md-5 separador"></div>
                </article>                                        
            </section>
            <Video urlVideo={urlVideo} />
        </section>  
    )
}

export default Home;